import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=ca738cce&scoped=true&"
import script from "./AccountDeletion.vue?vue&type=script&lang=js&"
export * from "./AccountDeletion.vue?vue&type=script&lang=js&"
import style0 from "./AccountDeletion.vue?vue&type=style&index=0&id=ca738cce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca738cce",
  null
  
)

export default component.exports